import Paper from "@mui/material/Paper";

export default function PaperContainer({ children, html, ...props }) {
    const aSx = {
        color: '#0d6efd',
        textDecoration: 'underline',
        cursor: 'pointer'
    }
    return (
        <Paper
            sx={{
                'h2, h3': {
                    fontWeight: 500,
                    fontSize: '18px',
                },
                '> p': {
                    fontSize: '14px',
                    '& a': aSx
                },
                '> a': aSx
            }}
            variant="renderHtml"
            dangerouslySetInnerHTML={{
                __html: html
            }}
            {...props}
        >
            {children}
        </Paper>
    )
}